import { render, staticRenderFns } from "./KasKecilUploadPhotoBox.vue?vue&type=template&id=60edcd5f&scoped=true&"
import script from "./KasKecilUploadPhotoBox.vue?vue&type=script&lang=js&"
export * from "./KasKecilUploadPhotoBox.vue?vue&type=script&lang=js&"
import style0 from "./KasKecilUploadPhotoBox.vue?vue&type=style&index=0&id=60edcd5f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60edcd5f",
  null
  
)

export default component.exports